import { useEffect, useRef, useState } from 'react'
import CapstonMark from '../components/CapstonMark'
import { api } from '../lib/api'
import ResendLinkPage from './ResendLinkPage'

// /p/<token>: the principal's personal link (#13). Unlike the admin's verify
// page there is no button — the link is reusable, so nothing is spent by
// opening it, and a mail scanner prefetching it gets a session cookie it
// cannot use. The exchange runs on load; success hands the signed-in user and
// their space to App.jsx, which lands them there. Anything else — expired,
// revoked, replaced, a space that has ended — shows the resend card.
export default function PrincipalLinkPage({ token, onSignedIn }) {
  const [failed, setFailed] = useState(false)
  // The callback is read through a ref so a re-render of App never re-fires
  // the exchange.
  const signedIn = useRef(onSignedIn)
  signedIn.current = onSignedIn

  useEffect(() => {
    let cancelled = false
    api('/api/v1/auth/principal', { method: 'POST', body: { token } })
      .then((me) => {
        if (!cancelled) signedIn.current(me)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
    }
  }, [token])

  if (failed) {
    return (
      <ResendLinkPage notice="This link has expired or has been replaced by a newer one." />
    )
  }

  return (
    <main
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: 'var(--color-surface-alt)' }}
    >
      <div className="card card--panel w-full" style={{ maxWidth: '420px' }}>
        <CapstonMark size={32} />
        <p className="overline" style={{ marginTop: 'var(--space-m)' }}>
          Capston
        </p>
        <h1 className="text-h3" style={{ marginBottom: 'var(--space-m)' }}>
          Experience
        </h1>
        <p className="text-body-md" style={{ color: 'var(--color-text-secondary)' }} role="status">
          Opening your space…
        </p>
      </div>
    </main>
  )
}
